@if (isWidgetVisible()) {
  <div
    (click)="onCloseClick()"
    class="search-categories-mobile-panel-overlay"
  ></div>

  <div
    [ngClass]="animationClass()"
    class="search-categories-mobile-panel"
  >
    <div class="search-categories-mobile-panel__header">
      @if (currentPage() !== 'main') {
        <button
          (click)="navigateBack()"
          aria-label="Tillbaka"
          class="icon-button navigate_back"
          type="button"
        >
          <app-ui-icon color="var(--grey-5)" name="chevron_back" size="md"></app-ui-icon>
        </button>
      }

      <div class="search-categories-mobile-panel__top-container">
        <div class="search-categories-mobile-panel__title">
          @switch (currentPage()) {
            @case ('main') {
              <span>Kategorier</span>
            }
            @case ('careServiceUnitGroups') {
              <span>Yrkeskategorier</span>
            }
            @case ('careServiceTypeGroups') {
              <span>Behandling</span>
            }
            @case ('symptomsGroups') {
              <span>Symptom</span>
            }
            @case ('careServiceUnits') {
              <span>{{ selectedCareServiceUnitGroup() }}</span>
            }
            @case ('careServiceTypes') {
              <span>{{ selectedCareServiceTypeGroup() }}</span>
            }
            @case ('symptoms') {
              <span>{{ selectedSymptomsGroup() }}</span>
            }
          }
        </div>
      </div>
      <button
        (click)="onCloseClick()"
        aria-label="Stäng"
        class="icon-button close"
        type="button"
      >
        <app-ui-icon color="var(--grey-5)" name="close" size="md"></app-ui-icon>
      </button>
    </div>
    <div class="search-categories-mobile-panel__body">
      <div class="search-categories-mobile-panel__inner">
        <div class="search-categories-mobile-panel__filters">
          <!-- Level 0 -->
          <!-- Main -->
          <div
            [style.display]="currentPage() === 'main' ? 'block' : 'none'"
            class="search-categories-mobile-panel__menu-level-0"
          >
            <div class="search-categories-mobile-panel__menu-level-0__list">
              @for (item of menuItems(); let i = $index; track item.label) {
                <div
                  (click)="selectMenuItem(i)"
                  class="search-categories-mobile-panel__menu-level-0__list-item"
                >
                  <div
                    class="search-categories-mobile-panel__menu-level-0__list-item__label title-6 bold test-mega-menu-menu-level-0-item">
                    {{ item.label }}
                  </div>

                  <app-ui-icon
                    color="var(--green-2)"
                    name="chevron_right"
                    size="sm"
                  ></app-ui-icon>
                </div>
              }
            </div>

            @if (widgetData()) {
              <div class="search-categories-mobile-panel__menu-level-0__popular flex flex-col gap-4 pt-4 pl-4 pr-3">
                <div
                  class="search-categories-mobile-panel__menu-level-0__popular__regular-header text-xs font-medium uppercase">
                  populära kategorier
                </div>

                <div
                  class="search-categories-mobile-panel__menu-level-0__popular__pill-items flex gap-4 justify-start content-start flex-wrap">
                  @for (item of widgetData().popularCaregiverUnitTypes; track item.id) {
                    <app-ui-button
                      (onClick)="onItemClick(item.routerLink, item.queryParams)"
                      [color]="'tertiary'"
                      [expanded]="'pill'"
                      [queryParams]="item.queryParams"
                      [routerLink]="item.routerLink"
                      [size]="'sm'"
                      class="test-mega-menu-pill-item"
                      tabindex="null"
                    >
                      {{ item.name }}
                    </app-ui-button>
                  }
                </div>
              </div>
            }

          </div>

          <!-- Level 1 -->
          <!-- Care Service Unit Groups -->
          <div [style.display]="currentPage() === 'careServiceUnitGroups' ? 'block' : 'none'"
               class="search-categories-mobile-panel__menu-level-1">
            <div class="search-categories-mobile-panel__menu-level-1__list">
              @for (group of careServiceUnitGroups(); let i = $index; track group.key) {
                <div
                  (click)="selectCareServiceUnitGroup(i)"
                  class="search-categories-mobile-panel__menu-level-1__list-item">
                  <div
                    class="search-categories-mobile-panel__menu-level-1__list-item__label body-2 regular test-mega-menu-menu-level-1-item">
                    <app-area-icon [area]="group.key"></app-area-icon>
                    <span>{{ group.key }}</span>
                  </div>
                  <app-ui-icon
                    color="var(--green-2)"
                    name="chevron_right"
                    size="sm"
                  ></app-ui-icon>
                </div>
              }
            </div>
          </div>

          <!-- Care Service Type Groups -->
          @if (appConfigService.appConfig.features.enableCareServicesInMegaMenu) {
            <div [style.display]="currentPage() === 'careServiceTypeGroups' ? 'block' : 'none'"
                 class="search-categories-mobile-panel__menu-level-1">
              <div class="search-categories-mobile-panel__menu-level-1__list">
                @for (group of careServiceTypeGroups(); let i = $index; track group.key) {
                  <div (click)="selectCareServiceTypeGroup(i)"
                       class="search-categories-mobile-panel__menu-level-1__list-item">
                    <div
                      class="search-categories-mobile-panel__menu-level-1__list-item__label body-2 regular test-mega-menu-menu-level-1-item">
                      <app-area-icon [area]="group.key"></app-area-icon>
                      <span class="uppercase">{{ group.key }}</span>
                    </div>
                    <app-ui-icon class="search-categories-mobile-panel__menu-level-1__list-item__icon"
                              name="chevron_right"></app-ui-icon>
                  </div>
                }
              </div>
            </div>
          }


          <!-- Symptoms Groups -->
          @if (appConfigService.appConfig.features.enableSymptomsInMegaMenu) {
            <div [style.display]="currentPage() === 'symptomsGroups' ? 'block' : 'none'"
                 class="search-categories-mobile-panel__menu-level-1">
              <div class="search-categories-mobile-panel__menu-level-1__list">
                @for (group of symptomsGroups(); let i = $index; track group.key) {
                  <div (click)="selectSymptomsGroup(i)" class="search-categories-mobile-panel__menu-level-1__list-item">
                    <div
                      class="search-categories-mobile-panel__menu-level-1__list-item__label body-2 regular test-mega-menu-menu-level-1-item">
                      <app-area-icon [area]="group.key"></app-area-icon>
                      <span class="uppercase">{{ group.key }}</span>
                    </div>
                    <app-ui-icon
                      color="var(--green-2)"
                      name="chevron_right"
                      size="sm"
                    ></app-ui-icon>
                  </div>
                }
              </div>
            </div>
          }


          <!-- Level 2 -->
          <!-- Care Service Units -->
          <div [style.display]="currentPage() === 'careServiceUnits' ? 'block' : 'none'"
               class="search-categories-mobile-panel__menu-level-2">
            <div class="search-categories-mobile-panel__menu-level-2__list">
              @for (unit of careServiceUnits(); let i = $index; track unit.id) {
                <div class="search-categories-mobile-panel__menu-level-2__list-item">
                  <a
                    (click)="onCareServiceUnitClick(unit.routerLink, unit.queryParams)"
                    [queryParams]="unit.queryParams"
                    [rel]="unit.noFollow ? 'nofollow' : ''"
                    [routerLink]="unit.routerLink"
                    class="search-categories-mobile-panel__menu-level-2__list-item__label body-2 regular test-mega-menu-menu-level-2-item"
                  >
                    {{ unit.name }}
                  </a>
                </div>
              }
            </div>
          </div>

          <!-- Care Service Types -->
          @if (appConfigService.appConfig.features.enableCareServicesInMegaMenu) {
            <div [style.display]="currentPage() === 'careServiceTypes' ? 'block' : 'none'"
                 class="search-categories-mobile-panel__menu-level-2">
              <div class="search-categories-mobile-panel__menu-level-2__list">
                @for (type of careServiceTypes(); let i = $index; track type.id) {
                  <div class="search-categories-mobile-panel__menu-level-2__list-item">
                    <a
                      (click)="onCareServiceTypeClick(type.routerLink, type.queryParams)"
                      [queryParams]="type.queryParams"
                      [rel]="type.noFollow ? 'nofollow' : ''"
                      [routerLink]="type.routerLink"
                      class="search-categories-mobile-panel__menu-level-2__list-item__label body-2 regular test-mega-menu-menu-level-2-item"
                    >
                      {{ type.name }}
                    </a>
                  </div>
                }
              </div>
            </div>
          }


          <!-- Symptoms -->
          @if (appConfigService.appConfig.features.enableSymptomsInMegaMenu) {
            <div
              [style.display]="currentPage() === 'symptoms' ? 'block' : 'none'"
              class="search-categories-mobile-panel__menu-level-2"
            >
              <div class="search-categories-mobile-panel__menu-level-2__list">
                @for (symptom of symptoms(); let i = $index; track symptom.id) {
                  <div class="search-categories-mobile-panel__menu-level-2__list-item">
                    <a
                      (click)="onSymptomClick(symptom.routerLink, symptom.queryParams)"
                      [queryParams]="symptom.queryParams"
                      [rel]="symptom.noFollow ? 'nofollow' : ''"
                      [routerLink]="symptom.routerLink"
                      class="search-categories-mobile-panel__menu-level-2__list-item__label body-2 regular test-mega-menu-menu-level-2-item"
                    >
                      {{ symptom.name }}
                    </a>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
